import type { Component } from 'vue';
import {
    Briefcase,
    Camera,
    Globe,
    Hash,
    ImagePlus,
    Music2,
    Play,
    Quote,
    ThumbsUp,
} from '@lucide/vue';

export type PlatformKey =
    | 'instagram'
    | 'facebook'
    | 'youtube'
    | 'linkedin'
    | 'tiktok'
    | 'website'
    | 'x'
    | 'pinterest'
    | 'threads';

/**
 * Platform presentation. Lucide does not ship brand marks, so each channel is
 * represented by a neutral icon plus its written name. Never rely on the icon
 * alone to communicate the channel.
 */
export const platforms: Record<
    PlatformKey,
    { label: string; icon: Component }
> = {
    instagram: { label: 'Instagram', icon: Camera },
    facebook: { label: 'Facebook', icon: ThumbsUp },
    youtube: { label: 'YouTube', icon: Play },
    linkedin: { label: 'LinkedIn', icon: Briefcase },
    tiktok: { label: 'TikTok', icon: Music2 },
    website: { label: 'Your website', icon: Globe },
    x: { label: 'X', icon: Hash },
    pinterest: { label: 'Pinterest', icon: ImagePlus },
    threads: { label: 'Threads', icon: Quote },
};
